export const docStatusDropDownItems = [
    { id: '100', name: 'Активный' },
    { id: '200', name: 'Архив' },
];
